<template>
    <div class="row mb-3">
        <div class="col-md-3">
            <label class="form-label">กรองตามยี่ห้อ</label>
            <tree-select
                :value="brandId"
                :options="brands"
                placeholder="ทั้งหมด"
                :clearable="true"
                @tree-select="onBrandSelect"
                @de-select="onBrandDeselect"
            />
        </div>
        <div class="col-md-3">
            <label class="form-label">กรองตามหมวดหมู่</label>
            <tree-select
                :value="categoryId"
                :options="categories"
                placeholder="ทั้งหมด"
                :clearable="true"
                @tree-select="onCategorySelect"
                @de-select="onCategoryDeselect"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'StockCountFilters',

    props: {
        brandId: {
            type: [String, Number],
            default: null,
        },
        categoryId: {
            type: [String, Number],
            default: null,
        },
        brands: {
            type: Array,
            default: () => [],
        },
        categories: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        onBrandSelect(node) {
            this.$emit('brand-select', node);
        },

        onBrandDeselect() {
            this.$emit('brand-deselect');
        },

        onCategorySelect(node) {
            this.$emit('category-select', node);
        },

        onCategoryDeselect() {
            this.$emit('category-deselect');
        },
    },
};
</script>
